import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import SubastaLotesList from "../views/SubastaLotesList/SubastaLotesList.vue";
import lotes from "../views/SubastaLotesList/SubastaLotes/Lotes/Lotes.vue"
import Home from "../views/Home/Home.vue";
import UserPanel from "../views/Users/UsersWeb/UserPanel.vue";
import UserPerfil from "../views/Users/UsersWeb/UserPerfil.vue";
import UserFavoritos from "../views/Users/UsersWeb/UserFavoritos.vue";
import UserCredito from "../views/Users/UsersWeb/UserCredito.vue";
import UserAuth from "../views/Users/UserAuth/UserAuth.vue";
import { useUsuarioStore } from "@/store/usuarioStore";
import ComoParticiparView from "../views/ComoParticipar/ComoParticiparView.vue";
import InstruccionesConMartillero from "../views/ComoParticipar/ConMartillero/InstruccionesConMartillero.vue";
import InstruccionesSinMartillero from "../views/ComoParticipar/SinMartillero/InstruccionesSinMartillero.vue";
import HistoriaDeOfertasView from "../views/HistorialDeOfertas/HistoriaDeOfertasView.vue";
import LotesCategoria from "../views/SubastaLotesList/SubastaLotes/LotesCategoria/LotesCategoria.vue";
import SubastasPrivadas from "../views/SubastasPrivadas/SubastasPrivadas.vue";
import { WarningGoogle } from "../utils/alerts";

const routes = [
  {
    path: "/estadisticas",
    name: "Estadisticas ",
    component: Dashboard,
  },
  {
    path: "/",
    name: "Grupo Adrián Mercado - Home",
    component: Home,
  },
  {
    path: "/subastas/lotes",
    name: "Subasta - Listado de lotes",
    component: SubastaLotesList,
  },
  {
    path: '/lotes/categorias/:id',
    name: "Subasta - Listado de lotes - en categoria",
    component: LotesCategoria,
  },
  {
    path: "/lotes",
    name: "Lotes",
    component: lotes,
  },
  // Subastas privadas por propietario slug
  {
    path: "/subasta-:slug",
    name: "SubastasPrivadas",
    component: SubastasPrivadas,
    meta: { requiresAuth: true },
  },
  // Usuarios auth
{
    path: '/login',
    name: 'Login',
    component: UserAuth,
    beforeEnter: (to) => {
      const raw = to.query?.error
      if (!raw) return true

      const msg = Array.isArray(raw) ? raw[0] : raw
      const message = decodeURIComponent(msg).replace(/\+/g, ' ')
      WarningGoogle(message)

      const rest = { ...to.query }
      delete rest.error

      return { name: 'Login', query: rest }
    },
    meta: { requiresAuth: false },
  },
  //Como Participar
  {
    path: "/como-participar",
    name: "ComoParticipar",
    component: ComoParticiparView,
    meta: { requiresAuth: false },
  },
  {
    path:'/con-martillero',
    name: "InstruccionesConMartillero",
    component: InstruccionesConMartillero,
  },
  {
    path:'/sin-martillero',
    name: "InstruccionesSinMartillero",
    component: InstruccionesSinMartillero,
  },
  // Usuarios web
  {
    path: "/usuario",
    name: "Panel",
    component: UserPanel,
    meta: { requiresAuth: true }, 
  },
  {
    path: "/usuario/perfil",
    name: "Perfil",
    component: UserPerfil,
    meta: { requiresAuth: true }, 

  },
  {
    path: "/usuario/favoritos",
    name: "Favoritos",
    component: UserFavoritos,
    meta: { requiresAuth: true }, 

  },
  {
    path: "/usuario/credito",
    name: "Credito",
    component: UserCredito,
    meta: { requiresAuth: true }, 

  },
  {
    path: "/usuario/historial",
    name: "Historial",
    component: HistoriaDeOfertasView,
    meta: { requiresAuth: true }, 

  },
  {
    path: "/confirmar-login-externo",
    name: "ConfirmarLoginExterno",
    beforeEnter: async (to) => {
      const usuarioStore = useUsuarioStore();

      await usuarioStore.confirmarLoginExterno({
        token: to.query.token,
        session_id: to.query.session_id,
        id: to.query.id,
      });
      
      window.location.href = `${process.env.VUE_APP_SISTEMA_SUBASTAS_ACTUAL_URL}/usuarios`;
      
    },
    meta: { requiresAuth: false },
  },

  {
    path: "/auth/google/callback",
    name: "iniciarConGoogle",
    beforeEnter: async (to) => {
      const token = to.query.token;

      if (!token) return (window.location.href = '/login');

      localStorage.setItem('token',token);

      window.location.href = '/';
    },
    meta: { requiresAuth: false },
  },

  {
    path: "/logout",
    name: "Logout",
    beforeEnter: async () => {
      const usuarioStore = useUsuarioStore();
  
      await usuarioStore.cerrarSesion();
  
    },
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token"); 

  if (to.meta.requiresAuth && !token) {
    next("/login");
  } else if (to.path === "/login" && token) {
    next("/usuario");
  } else {
    next();
  }
});

export default router;
